const accountToOption = ({ id: value, name: label }) => ({ value, label });

export function asFormOptions(accounts) {
  return accounts.map(accountToOption);
}
